import React from "react";
import {formatApiError} from "../api";

interface ErrorBannerProps {
    /** Произвольная ошибка (ApiError, Error, строка) или null. */
    error: unknown;
    /** Необязательный заголовок перед сообщением. */
    title?: string;
}

/**
 * Переиспользуемый показ ошибки запроса (для admin-экранов B/C).
 * Принимает значение как из `catch` (unknown) — превращает его в
 * читаемую строку через formatApiError и рисует alert-error.
 */
export function ErrorBanner({error, title}: ErrorBannerProps): JSX.Element | null {
    if (error === null || error === undefined || error === "") return null;

    const message =
        typeof error === "string" ? error : formatApiError(error);

    return (
        <div className="alert alert-error" role="alert">
            {title ? <strong>{title}: </strong> : null}
            {message}
        </div>
    );
}
